import React, { createContext, useContext, useState } from "react";

// =====================================================
// SKILLS DATA — hardcoded in DE & EN
// =====================================================
const skillsData = {
  de: [
    {
      categoryImg: "prog.svg",
      categoryAlt: "Programmiersprachen",
      items: [
        {
          img: "java.svg",
          title: "Java",
          description:
            "Java ist eine Programmiersprache und Laufzeitumgebung, die 1995 von Sun Microsystems veröffentlicht wurde. Eine täglich wachsende Anzahl von Anwendungen und Websites benötigt Java. Java ist schnell, sicher und zuverlässig.",
        },
        {
          img: "python.svg",
          title: "Python",
          description:
            "Python ist eine universelle, interpretierte Programmiersprache mit Fokus auf einfache Lesbarkeit. Mit klarer Syntax und riesiger Standardbibliothek wird Python in Webentwicklung, Datenwissenschaft und KI eingesetzt.",
        },
        {
          img: "dart.svg",
          title: "Dart",
          description:
            "Dart ist eine von Google entwickelte Programmiersprache. Ursprünglich für den Chrome-Browser erstellt, wird sie heute intensiv für das Flutter-Framework genutzt.",
        },
        {
          img: "flutter.svg",
          title: "Flutter",
          description:
            "Flutter ist ein Open-Source-UI-Kit von Google. Mit Flutter können Cross-Platform Apps in Dart entwickelt werden – eine App läuft auf Android, iOS, Web, Windows, Linux, macOS und Fuchsia.",
        },
        {
          img: "mitapp.svg",
          title: "MIT App Inventor",
          description:
            "MIT App Inventor ist eine von Google entwickelte Entwicklungsumgebung für Android-Apps. Die grafische Oberfläche ermöglicht es, per Drag & Drop aus grafischen Blöcken Apps zu erstellen.",
        },
        {
          img: "processing.svg",
          title: "Processing",
          description:
            "Processing ist eine objektorientierte Programmiersprache mit eigener Entwicklungsumgebung, spezialisiert auf Grafik, Simulation und Animation.",
        },
      ],
    },
    {
      categoryImg: "progh.svg",
      categoryAlt: "Web-Entwicklung",
      items: [
        {
          img: "html.svg",
          title: "HTML",
          description:
            "HTML (Hypertext Markup Language) strukturiert Webinhalte und gibt Elementen wie Absätzen, Bildern und Tabellen Bedeutung und Zweck.",
        },
        {
          img: "css.svg",
          title: "CSS",
          description:
            "CSS (Cascading Style Sheets) bestimmt das Design von Webseiten. Mit einfachen Anweisungen werden Layout, Farbe und Typografie von Elementen angepasst.",
        },
        {
          img: "js.svg",
          title: "JavaScript",
          description:
            "JavaScript ermöglicht interaktive Inhalte auf Webseiten: Spiele, Reaktionen auf Klicks, dynamisches Design, Animationen und vieles mehr.",
        },
        {
          img: "php.svg",
          title: "PHP",
          description:
            "PHP (PHP: Hypertext Preprocessor) ist eine weit verbreitete Open-Source-Skriptsprache für Webprogrammierung, die direkt in HTML eingebettet werden kann.",
        },
      ],
    },
    {
      categoryImg: "addobe.svg",
      categoryAlt: "Adobe Programme",
      items: [
        {
          img: "ae.svg",
          title: "Adobe After Effects",
          description:
            "Adobe After Effects ist ein Programm für Grafikanimationen und Spezialeffekte in der Film- und Video-Postproduktion.",
        },
        {
          img: "au.svg",
          title: "Adobe Audition",
          description:
            "Adobe Audition ist ein professionelles Programm für Audioaufnahme, -bearbeitung und -mischung.",
        },
        {
          img: "ai.svg",
          title: "Adobe Illustrator",
          description:
            "Adobe Illustrator ist das führende Programm für Vektorgrafik und Illustration – genutzt weltweit für Logos, Icons und komplexe Illustrationen.",
        },
        {
          img: "id.svg",
          title: "Adobe InDesign",
          description:
            "Adobe InDesign ist das führende Design- und Layout-Programm für professionellen Satz, Druckvorstufe und digitale Publikationen.",
        },
        {
          img: "ps.svg",
          title: "Adobe Photoshop",
          description:
            "Adobe Photoshop ist die führende Software für Bildbearbeitung und Grafik-Design, verfügbar für Desktop und Tablet (iPad, seit 2019).",
        },
        {
          img: "lr.svg",
          title: "Adobe Lightroom",
          description:
            "Adobe Lightroom ist ein cloudbasiertes, geräteübergreifendes Programm zum Bearbeiten und Verwalten von Fotos – für Desktop und Mobile.",
        },
        {
          img: "lrc.svg",
          title: "Adobe Lightroom Classic",
          description:
            "Adobe Lightroom Classic ist ein Desktop-Programm für Verwaltung und Bearbeitung von Fotos und Videos.",
        },
        {
          img: "pr.svg",
          title: "Adobe Premiere Pro",
          description:
            "Adobe Premiere Pro ist ein professionelles Videobearbeitungsprogramm mit Werkzeugen für Schnitt, Farbkorrektur und Audio-Mix.",
        },
        {
          img: "xd.svg",
          title: "Adobe XD",
          description:
            "Adobe XD (Experience Design) ist ein Programm zur Erstellung von Prototypen und digitalen User Experiences für Webseiten, Apps, Voice UI oder Games.",
        },
      ],
    },
    {
      categoryImg: "web.svg",
      categoryAlt: "Web-Tools",
      items: [
        {
          img: "wordpress.svg",
          title: "WordPress",
          description:
            "WordPress ist das beliebteste Content Management System weltweit und bietet alles für eine professionelle Website.",
        },
        {
          img: "Wix.svg",
          title: "Wix",
          description:
            "Wix bietet alle professionellen Web-Funktionen für Unternehmen. Mit einer eigenen Domain entsteht ein professioneller Onlineauftritt, verwaltet über eine einzige Oberfläche.",
        },
        {
          img: "googlesite.svg",
          title: "Google Sites",
          description:
            "Google Sites ist ein Webhosting-Dienst von Google. Registrierte NutzerInnen können mithilfe eines Baukastensystems kostenlos Websites erstellen.",
        },
      ],
    },
  ],

  en: [
    {
      categoryImg: "prog.svg",
      categoryAlt: "Programming Languages",
      items: [
        {
          img: "java.svg",
          title: "Java",
          description:
            "Java is a programming language and runtime environment first released by Sun Microsystems in 1995. A growing number of applications and websites require Java. Java is fast, secure, and reliable.",
        },
        {
          img: "python.svg",
          title: "Python",
          description:
            "Python is a universal, interpreted programming language focused on readability. With a clear syntax and a huge standard library, Python is used in web development, data science, and AI.",
        },
        {
          img: "dart.svg",
          title: "Dart",
          description:
            "Dart is a programming language developed by Google. Originally created for the Chrome browser, it is now actively developed for the Flutter framework.",
        },
        {
          img: "flutter.svg",
          title: "Flutter",
          description:
            "Flutter is an open-source UI toolkit from Google. Cross-platform apps built in Dart run on Android, iOS, Web, Windows, Linux, macOS, and Fuchsia from a single codebase.",
        },
        {
          img: "mitapp.svg",
          title: "MIT App Inventor",
          description:
            "MIT App Inventor is an integrated development environment originally created by Google for building Android apps via drag-and-drop graphical code blocks.",
        },
        {
          img: "processing.svg",
          title: "Processing",
          description:
            "Processing is an object-oriented programming language with its own IDE, specializing in graphics, simulation, and animation.",
        },
      ],
    },
    {
      categoryImg: "progh.svg",
      categoryAlt: "Web Development",
      items: [
        {
          img: "html.svg",
          title: "HTML",
          description:
            "HTML (Hypertext Markup Language) structures web content, giving elements like paragraphs, images, and tables meaning and purpose.",
        },
        {
          img: "css.svg",
          title: "CSS",
          description:
            "CSS (Cascading Style Sheets) defines the visual design of web pages, allowing customization of layout, color, and typography.",
        },
        {
          img: "js.svg",
          title: "JavaScript",
          description:
            "JavaScript enables interactive content on websites: games, click reactions, dynamic styling, animations, and much more.",
        },
        {
          img: "php.svg",
          title: "PHP",
          description:
            "PHP (PHP: Hypertext Preprocessor) is a widely used open-source scripting language for web programming that can be embedded directly in HTML.",
        },
      ],
    },
    {
      categoryImg: "addobe.svg",
      categoryAlt: "Adobe Software",
      items: [
        {
          img: "ae.svg",
          title: "Adobe After Effects",
          description:
            "Adobe After Effects is a software program for graphic animations and special effects, used in post-production for film and video.",
        },
        {
          img: "au.svg",
          title: "Adobe Audition",
          description:
            "Adobe Audition is a professional audio program for recording, editing, and mixing audio content.",
        },
        {
          img: "ai.svg",
          title: "Adobe Illustrator",
          description:
            "Adobe Illustrator is the leading software for vector graphics and illustration, used worldwide for logos, icons, typography, and complex illustrations.",
        },
        {
          img: "id.svg",
          title: "Adobe InDesign",
          description:
            "Adobe InDesign is the leading design and layout program for professional typesetting, print pre-press, and digital publications.",
        },
        {
          img: "ps.svg",
          title: "Adobe Photoshop",
          description:
            "Adobe Photoshop is the leading software for image editing and graphic design, available for desktop and tablet (iPad, since 2019).",
        },
        {
          img: "lr.svg",
          title: "Adobe Lightroom",
          description:
            "Adobe Lightroom is a cloud-based, cross-device program for editing and managing photos, available for desktop and mobile.",
        },
        {
          img: "lrc.svg",
          title: "Adobe Lightroom Classic",
          description:
            "Adobe Lightroom Classic is a desktop program for managing and editing photos and videos.",
        },
        {
          img: "pr.svg",
          title: "Adobe Premiere Pro",
          description:
            "Adobe Premiere Pro is a professional video editing program with extensive tools for cutting, color correction, and audio mixing.",
        },
        {
          img: "xd.svg",
          title: "Adobe XD",
          description:
            "Adobe XD (Experience Design) is a program for creating prototypes and digital user experiences for websites, apps, voice UIs, and games.",
        },
      ],
    },
    {
      categoryImg: "web.svg",
      categoryAlt: "Web Tools",
      items: [
        {
          img: "wordpress.svg",
          title: "WordPress",
          description:
            "WordPress is the world's most popular content management system, providing everything needed to build a professional website.",
        },
        {
          img: "Wix.svg",
          title: "Wix",
          description:
            "Wix offers all the professional web features a business needs. With a custom domain it provides a polished online presence managed from a single dashboard.",
        },
        {
          img: "googlesite.svg",
          title: "Google Sites",
          description:
            "Google Sites is a web hosting service by Google that lets registered users build professional websites for free using a drag-and-drop builder.",
        },
      ],
    },
  ],
};

// =====================================================
// UI TRANSLATIONS
// =====================================================
const translations = {
  de: {
    nav: {
      home: "Home",
      skills: "Skills",
      projects: "Projekte",
      contact: "Kontakt",
    },
    navContact: {
      nameLabel: "Name",
      addressLabel: "Adresse",
    },
    hero: {
      tagline: "Hoope",
    },
    contact: {
      subtitle: "Programmierer & Designer · Hallein, Österreich",
      nameLabel: "Name",
      addressLabel: "Adresse",
      socialMedia: "Social Media",
    },
  },
  en: {
    nav: {
      home: "Home",
      skills: "Skills",
      projects: "Projects",
      contact: "Contact",
    },
    navContact: {
      nameLabel: "Name",
      addressLabel: "Address",
    },
    hero: {
      tagline: "Developer & Designer",
    },
    contact: {
      subtitle: "Developer & Designer · Hallein, Austria",
      nameLabel: "Name",
      addressLabel: "Address",
      socialMedia: "Social Media",
    },
  },
};

// =====================================================
// CONTEXT
// =====================================================
const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("de");
  const toggleLang = () => setLang((prev) => (prev === "de" ? "en" : "de"));

  return (
    <LanguageContext.Provider
      value={{
        lang,
        t: translations[lang],
        skills: skillsData[lang],
        toggleLang,
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
export default LanguageContext;
